/* eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }] */
import XRegExp from 'xregexp';
import crc from 'crc';

const twoNumbersRegEx = new XRegExp('^[0-9]{2}$');
const numberOnlyRegEx = new XRegExp('^[0-9]*$');
const TQRAmountRegEx = new XRegExp('^([0-9]+)([.]*)([0-9]+)$');

const formatBOT = 'มาตรฐานของ BOT';
const formatThaiQR = 'มาตรฐานของ Thai QR 1.3.3';

const TQRIDwithSubdata = ['26', '27', '29', '30', '31', '39', '51', '62', '80'];

const QRChecker = {
  /**
   * Get QR Code Format
   */
  getVerificationResult({ result }) {
    let format = 'ไม่ตรงตามมาตรฐานของ BOT หรือ Thai QR 1.3.3';
    let correctness = false;
    let incorrectReason = '';
    // check type
    if (result.substr(0, 1) === '|') {
      format = formatBOT;

      const parts = result.substr(1).split('\r');
      if (parts.length >= 4) {
        if (parts[0].length !== 15) {
          incorrectReason = this.appendIncorrectReason(incorrectReason, 'Tax ID + Suffix มีจำนวนไม่เท่ากับ 15 หลัก');
        }

        if (parts[1].length > 20) {
          incorrectReason = this.appendIncorrectReason(incorrectReason, 'Ref. 1 มีจำนวนมากกว่า 20 หลัก');
        }

        if (parts[2].length > 20) {
          incorrectReason = this.appendIncorrectReason(incorrectReason, 'Ref. 2 มีจำนวนมากกว่า 20 หลัก');
        }

        if (parts[3].length < 1 || parts[3].length > 10) {
          incorrectReason = this.appendIncorrectReason(incorrectReason, 'Total Amount มีจำนวนน้อยกว่า 1 หลัก หรือมากกว่า 10 หลัก');
        }

        if (!numberOnlyRegEx.test(parts[3])) {
          incorrectReason = this.appendIncorrectReason(incorrectReason, 'Total Amount มีตัวอักษรแทรกอยู่');
        }

        if (incorrectReason === '') {
          correctness = true;
        }
      } else {
        incorrectReason = 'ไม่พบตัวอักษร Carriage Return หรือ มีข้อมูลไม่ครบอย่างน้อย 4 field (TaxID+Suffix, Ref.1, Ref.2, TotalAmount)';
      }
    } else if (result.substr(0, 6) === '000201') {
      format = formatThaiQR;

      const dataExclChecksum = result.substr(0, result.length - 4);
      const calCRC = crc.crc16xmodem(dataExclChecksum, 0xffff).toString(16).toUpperCase();

      const res = this.splitTQRData(result.substr(6));
      // console.log(res);
      if (res.success === false) {
        incorrectReason = this.appendIncorrectReason(incorrectReason, 'ไม่สามารถถอดรหัสในรูปแบบ [ID:Length:Data] ได้');
        incorrectReason = this.appendIncorrectReason(incorrectReason, res.failedReason);
        return { format, correctness, incorrectReason };
      }

      for (let i = 0; i < res.dataParts.length; i++) {
        const dataPart = res.dataParts[i];
        if (dataPart.id === '52') {
          if (!numberOnlyRegEx.test(dataPart.d) || dataPart.d.length !== 4) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${dataPart.id} มีความยาวข้อมูลมากกว่า 4 หรือมีตัวอักษรแทรกอยู่ในข้อมูล`);
          }
        }

        if (dataPart.id === '53') {
          if (dataPart.d !== '764') {
            incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${dataPart.id} ข้อมูลไม่ใช่ 764`);
          }
        }

        if (dataPart.id === '54') {
          if (!TQRAmountRegEx.test(dataPart.d) || dataPart.d.length > 13) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${dataPart.id} พบข้อมูลจำนวนเงินผิดรูปแบบ`);
          }
        }

        if (dataPart.id === '55') {
          if (!numberOnlyRegEx.test(dataPart.d) || dataPart.d.length !== 2) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${dataPart.id} มีความยาวข้อมูลมากกว่า 2 หรือมีตัวอักษรแทรกอยู่ในข้อมูล`);
          }
        }

        if (dataPart.id === '56') {
          if (!TQRAmountRegEx.test(dataPart.d) || dataPart.d.length > 13) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${dataPart.id} พบข้อมูลผิดรูปแบบจำนวนเงิน`);
          }
        }

        if (dataPart.id === '57') {
          if (!TQRAmountRegEx.test(dataPart.d) || dataPart.d.length > 5) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${dataPart.id} พบข้อมูลผิดรูปแบบ percentage`);
          }
        }

        if (dataPart.id === '58') {
          if (dataPart.d !== 'TH') {
            incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${dataPart.id} ข้อมูลไม่ใช่ 'TH'`);
          }
        }

        if (dataPart.id === '59') {
          if (dataPart.d.length > 25) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${dataPart.id} มีความยาวข้อมูลมากกว่า 25`);
          }
        }

        if (dataPart.id === '60') {
          if (dataPart.d.length > 15) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${dataPart.id} มีความยาวข้อมูลมากกว่า 15`);
          }
        }

        if (dataPart.id === '61') {
          if (dataPart.d.length > 10) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${dataPart.id} มีความยาวข้อมูลมากกว่า 10`);
          }
        }

        if (dataPart.id === '64') {
          if (dataPart.d.length > 99) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${dataPart.id} มีความยาวข้อมูลมากกว่า 99`);
          }
        }

        if (dataPart.id === '63') {
          if (dataPart.d.length > 4 || dataPart.d !== calCRC) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${dataPart.id} Checksum ไม่ถูกต้อง (ที่ถูกต้องคือ ${calCRC})`);
          }
        }

        if (TQRIDwithSubdata.includes(dataPart.id)) {
          const res2 = this.splitTQRData(dataPart.d);
          const parentID = dataPart.id;
          for (let j = 0; j < res2.dataParts.length; j++) {
            const subPart = res2.dataParts[j];
            if (parentID === '29') { // promptpay
              if (subPart.id === '01') { // mobile number
                if (!numberOnlyRegEx.test(subPart.d) || subPart.d.substr(0, 4) !== '0066') {
                  incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${parentID}(${subPart.id}) เบอร์โทรศัพท์มือถือไม่ขึ้นต้นด้วย 0066 หรือ มีตัวอักษรแทรกอยู่`);
                }
              }

              if (subPart.id === '02') { // nat id
                if (!numberOnlyRegEx.test(subPart.d)) {
                  incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${parentID}(${subPart.id}) National ID or Tax ID มีตัวอักษรแทรกอยู่`);
                }
              }

              if (subPart.id === '03') { // e wallet
                if (!numberOnlyRegEx.test(subPart.d)) {
                  incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${parentID}(${subPart.id}) E-Wallet ID มีตัวอักษรแทรกอยู่`);
                }
              }

              if (subPart.id === '04') { // bank account
                if (!numberOnlyRegEx.test(subPart.d)) {
                  incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${parentID}(${subPart.id}) Bank account มีตัวอักษรแทรกอยู่`);
                }
              }

              if (subPart.id === '05') { // OTA
                if (subPart.d !== 'A000000677010114') {
                  incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${parentID}(${subPart.id}) OTA ไม่ใช่ A000000677010114`);
                }
              }
            }

            if (parentID === '30') { // promptpay bill payment
              if (subPart.id === '00') {
                if (subPart.d !== 'A000000677010112') {
                  incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${parentID}(${subPart.id}) AID ไม่ใช่ A000000677010112`);
                }
              }

              if (subPart.id === '01') { // biller id
                if (!numberOnlyRegEx.test(subPart.d)) {
                  incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${parentID}(${subPart.id}) Biller ID มีตัวอักษรแทรกอยู่`);
                }
              }

              if (subPart.id === '02') { // ref1
                if (subPart.d.length > 20) {
                  incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${parentID}(${subPart.id}) Reference 1 มีความยาวข้อมูลมากกว่า 20`);
                }
              }

              if (subPart.id === '03') { // ref2
                if (subPart.d.length > 20) {
                  incorrectReason = this.appendIncorrectReason(incorrectReason, `ID: ${parentID}(${subPart.id}) Reference 2 มีความยาวข้อมูลมากกว่า 20`);
                }
              }
            }
          } // sub data for loop
        } // if subdata
      } // for loop

      if (incorrectReason === '') {
        correctness = true;
      }
    } // else format TQR
    return { format, correctness, incorrectReason };
  },

  getHTMLInfo(format, { result }) {
    let info = '';
    if (format === formatBOT) {
      info = result.split('\r').join('<br/>');
    } else if (format === formatThaiQR) {
      const res = this.splitTQRData(result);
      for (let i = 0; i < res.dataParts.length; i++) {
        if (TQRIDwithSubdata.includes(res.dataParts[i].id)) {
          info = `${info}<br/> ${res.dataParts[i].id} ${res.dataParts[i].len}`;
          const res2 = this.splitTQRData(res.dataParts[i].d);
          for (let j = 0; j < res2.dataParts.length; j++) {
            info = `${info}<br/> &nbsp; ${res2.dataParts[j].id} ${res2.dataParts[j].len} ${res2.dataParts[j].d}`;
          }
          info = `${info}<br/> ${res2.data}`;
        } else {
          info = `${info}<br/> ${res.dataParts[i].id} ${res.dataParts[i].len} ${res.dataParts[i].d}`;
        }
      }
      info = `${info}<br/> ${res.data}<br/>`;
    } else {
      info = result;
    }
    return info;
  },

  appendIncorrectReason(currentStr, appendingStr) {
    let str = '';
    if (currentStr === '') {
      str = `- ${appendingStr}`;
    } else {
      str = `${currentStr}<br/>-  ${appendingStr}`;
    }
    return str;
  },

  splitTQRData(rawData) {
    let data = rawData;
    let success = true;
    const dataParts = [];
    let failedReason = '';
    while (data.length > 0) {
      let cursor = 0;
      const id = data.substr(cursor, 2);
      const len = data.substr(cursor + 2, 2);
      if (!twoNumbersRegEx.test(id) || !twoNumbersRegEx.test(len)) {
        success = false;
        failedReason = 'พบตัวอักษรใน field ID หรือ Length';
        return { success, dataParts, data, failedReason };
      }

      const dLen = parseInt(len, 10);
      const d = data.substr(cursor + 4, dLen);

      dataParts.push({ id, len, d });
      if ((d.length !== dLen) || (dLen < 1)) {
        success = false;
        failedReason = 'พบข้อมูลมีความยาวไม่ตรงกับที่ระบุใน field Length';
        return { success, dataParts, data, failedReason };
      }

      cursor = cursor + 4 + dLen;
      data = data.substr(cursor);
    }
    return { success, dataParts, data, failedReason };
  },
};

export default QRChecker;



// WEBPACK FOOTER //
// ./src/libs/qr.js